/* Buying-guide article page (sections/sf-article.liquid).
   Enhances the plain article HTML in #ga-body; without JS the article still reads normally. */
(function () {
  var root = document.getElementById('ga');
  var body = document.getElementById('ga-body');
  if (!root || !body) return;
  var handle = (root.getAttribute('data-handle') || '').split('/').pop();   // article.handle is "blog/article"
  var WA = 'https://wa.me/60178056033?text=';

  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function slug(s) { return s.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60); }
  function rm(cents) { return 'RM' + (cents / 100).toLocaleString('en-MY', { maximumFractionDigits: 0 }); }
  function img(src, w) { if (!src) return ''; return (src.indexOf('//') === 0 ? 'https:' + src : src) + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }

  /* ---- product data, fetched once per handle ---- */
  var cache = {};
  function product(h) {
    if (!cache[h]) cache[h] = fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    return cache[h];
  }
  function card(h, note) {
    var a = el('a', 'ga-pc is-loading');
    a.href = '/products/' + h;
    a.innerHTML = '<span class="ga-pc-img"></span><span class="ga-pc-txt"><small></small><b></b><em></em>' + (note ? '<i>' + note + '</i>' : '') + '</span><span class="ga-pc-go">&rarr;</span>';
    product(h).then(function (p) {
      a.classList.remove('is-loading');
      if (!p) { a.remove(); return; }
      a.href = p.url || a.href;
      if (p.featured_image) a.querySelector('.ga-pc-img').innerHTML = '<img src="' + img(p.featured_image, 360) + '" alt="' + p.title.replace(/"/g, '&quot;') + '" loading="lazy">';
      a.querySelector('small').textContent = p.vendor || '';
      a.querySelector('b').textContent = p.title;
      a.querySelector('em').textContent = (p.price_varies ? 'from ' : '') + rm(p.price);
    });
    return a;
  }
  function firstNode(li) { var n = li.firstChild; while (n && n.nodeType === 3 && !n.textContent.trim()) n = n.nextSibling; return n; }
  function handleOf(a) { var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/); return m ? m[1] : null; }

  /* ---- 1. group the article into sections by <h2> ---- */
  var secs = [];
  Array.prototype.slice.call(body.querySelectorAll(':scope > h2')).forEach(function (h2) {
    var sec = el('section', 'ga-sec');
    sec.id = slug(h2.textContent);
    h2.parentNode.insertBefore(sec, h2);
    var n = h2;
    while (n && !(n !== h2 && n.nodeType === 1 && n.tagName === 'H2')) { var next = n.nextSibling; sec.appendChild(n); n = next; }
    secs.push(sec);
  });

  /* ---- 2. contents menu + reading progress ---- */
  var toc = document.getElementById('ga-toc');
  var links = secs.map(function (s, i) {
    var li = el('li'); var a = el('a'); a.href = '#' + s.id; a.textContent = s.querySelector('h2').textContent;
    li.appendChild(a); if (toc) toc.appendChild(li); return a;
  });
  var bar = root.querySelector('.ga-progress i');
  function onScroll() {
    var r = body.getBoundingClientRect(), h = r.height - window.innerHeight * 0.6;
    var p = Math.min(1, Math.max(0, -r.top / (h > 0 ? h : 1)));
    if (bar) bar.style.transform = 'scaleX(' + p + ')';
    var cur = 0;
    secs.forEach(function (s, i) { if (s.getBoundingClientRect().top < window.innerHeight * 0.35) cur = i; });
    links.forEach(function (a, i) { a.classList.toggle('on', i === cur); });
  }
  window.addEventListener('scroll', onScroll, { passive: true }); onScroll();

  /* ---- 3. "The short answer" -> decision cards ---- */
  secs.forEach(function (s) {
    if (!/short answer|jawapan ringkas|简短回答/i.test(s.querySelector('h2').textContent)) return;
    s.classList.add('ga-short');
    var ul = s.querySelector('ul'); if (ul) ul.className = 'ga-decide';
  });

  /* ---- 4. lists of product links -> product cards ---- */
  Array.prototype.slice.call(body.querySelectorAll('ul')).forEach(function (ul) {
    // a line counts as a product line when it starts with a product link; other lines stay as text below the cards
    var prod = Array.prototype.slice.call(ul.children).filter(function (li) { var f = li.firstElementChild; return f && f.tagName === 'A' && handleOf(f) && firstNode(li) === f; });
    if (prod.length < 2) return;
    var grid = el('div', 'ga-pcs');
    prod.forEach(function (li) {
      var a = li.firstElementChild, h = handleOf(a);
      var note = li.textContent.replace(a.textContent, '').replace(/^[\s,:–—-]+/, '').replace(/^RM[\d,]+[\s:,]*/, '').trim().replace(/^[.\s]+$/, '');
      grid.appendChild(card(h, note));
      li.remove();
    });
    ul.parentNode.insertBefore(grid, ul);
    if (!ul.children.length) ul.remove();
  });

  /* ---- 5. comparison tables ---- */
  Array.prototype.slice.call(body.querySelectorAll('table')).forEach(function (t) {
    var w = el('div', 'ga-table'); t.parentNode.insertBefore(w, t); w.appendChild(t);
    var first = t.querySelector('tr'); if (first) first.classList.add('ga-th');
  });

  /* ---- 6. FAQ -> accordions (FAQPage data for search engines too) ---- */
  var faq = [];
  secs.forEach(function (s) {
    if (!/frequently asked|soalan lazim|常见问题/i.test(s.querySelector('h2').textContent)) return;
    s.classList.add('ga-faq');
    Array.prototype.slice.call(s.querySelectorAll('h3')).forEach(function (h3, i) {
      var d = el('details'); if (i === 0) d.open = true;
      var sm = el('summary'); sm.textContent = h3.textContent; d.appendChild(sm);
      var ans = el('div', 'ga-ans'); var n = h3.nextSibling;
      while (n && !(n.nodeType === 1 && /^H[23]$/.test(n.tagName))) { var nx = n.nextSibling; ans.appendChild(n); n = nx; }
      d.appendChild(ans); h3.parentNode.replaceChild(d, h3);
      faq.push({ '@type': 'Question', name: sm.textContent, acceptedAnswer: { '@type': 'Answer', text: ans.textContent.trim() } });
    });
  });
  if (faq.length) { var ld = el('script'); ld.type = 'application/ld+json'; ld.textContent = JSON.stringify({ '@context': 'https://schema.org', '@type': 'FAQPage', mainEntity: faq }); document.head.appendChild(ld); }

  /* ---- 7. closing "need help?" section -> callout ---- */
  var last = secs[secs.length - 1];
  if (last && !last.classList.contains('ga-faq')) last.classList.add('ga-help');

  /* ---- 8. interactive tool for this guide ---- */
  var TOOLS = {
    'stand-mixer-vs-spiral-mixer-malaysia': {
      kind: 'picker', after: 'ga-short',
      title: 'Find your mixer in 2 taps',
      qs: [
        { id: 'what', q: 'What do you bake most?', a: [['cakes', 'Cakes, cookies & cream'], ['bread', 'Bread, pizza & buns'], ['both', 'A bit of both']] },
        { id: 'size', q: 'How much dough or batter per batch?', a: [['s', 'Under 2 kg'], ['m', '2 – 5 kg'], ['l', '5 – 8 kg'], ['xl', 'More than 8 kg']] }
      ],
      result: function (v) {
        var R = {
          'cakes-s': ['A home stand mixer', 'A planetary stand mixer whisks, creams and kneads light dough. At this size a home model is plenty.', ['orimas-em1208', 'kitmens-km-b7', 'kitchenaid-5ksm175']],
          'cakes-m': ['A commercial planetary mixer', 'For daily batches of batter and cream, a commercial planetary mixer runs longer without overheating.', ['spar-sp-800', 'spar-sp-800a']],
          'cakes-l': ['A 10 – 20 L planetary mixer', 'Bigger bowls let you mix a full day of batter in fewer batches.', ['spar-sp-5mx', 'spar-sp-200a']],
          'cakes-xl': ['A floor-standing planetary mixer', 'For bakery volumes, step up to a 25 – 40 L floor model.', ['spar-sp-25ma', 'spar-sp-40ma']],
          'bread-s': ['A compact spiral mixer', 'A spiral mixer kneads like hand-kneading and keeps dough cool, even at small batches.', ['mybaker-my-07ahs', 'the-baker-smes10']],
          'bread-m': ['A 10 L spiral mixer', 'The sweet spot for home businesses: up to 5 – 7 kg of dough per batch.', ['the-baker-smes10', 'mybaker-my-10hsd']],
          'bread-l': ['A 20 L spiral mixer', 'Room for 8 kg batches, so you mix less often.', ['the-baker-smes20', 'sunmix-easy20']],
          'bread-xl': ['A bakery spiral mixer', 'For large daily production, an Italian spiral mixer built for continuous use.', ['sunmix-sun30-tl-a', 'sunmix-evo20']],
          'both-s': ['One of each', 'A compact spiral for dough, and a stand mixer for cakes and cream.', ['mybaker-my-07ahs', 'kitmens-km-b7']],
          'both-m': ['One of each', 'A 10 L spiral for bread, and a commercial planetary for batters and cream.', ['the-baker-smes10', 'spar-sp-800']],
          'both-l': ['One of each', 'A 20 L spiral for dough, and a 10 L planetary for everything else.', ['the-baker-smes20', 'spar-sp-5mx']],
          'both-xl': ['One of each', 'A bakery spiral for dough, and a 20 L planetary for batters and cream.', ['sunmix-sun30-tl-a', 'spar-sp-200a']]
        };
        return R[v.what + '-' + v.size];
      }
    },
    'deck-convection-combi-oven-malaysia': {
      kind: 'picker', after: 'ga-short',
      title: 'Find your oven in 2 taps',
      qs: [
        { id: 'what', q: 'What will you bake most?', a: [['bread', 'Bread, sourdough & pizza'], ['pastry', 'Cakes, cookies & pastry'], ['cook', 'Baking and cooking']] },
        { id: 'trays', q: 'How many trays at once?', a: [['few', '1 – 2 trays'], ['mid', '4 – 6 trays'], ['many', '8 trays or more']] }
      ],
      result: function (v) {
        var R = {
          'bread-few': ['A single-deck oven', 'A hot stone deck gives bread and pizza a crisp base and good rise.', ['orimas-gu-1m', 'bulli-dsl-1k']],
          'bread-mid': ['A two-deck oven, or convection with steam', 'More decks for more loaves, or a steam convection oven if you also bake pastry.', ['orimas-gu-2m', 'soner-sco-4mf']],
          'bread-many': ['A bakery combi or multi-deck oven', 'For high output with steam and programs, a bakery combi oven keeps every batch consistent.', ['unox-xebc-04eu-e1rm', 'unox-xeda-1011-exrs']],
          'pastry-few': ['A countertop convection oven', 'A fan oven bakes evenly on every shelf, perfect for cookies and cakes.', ['kitmens-km-co50', 'innofood-ktbf1a']],
          'pastry-mid': ['A convection oven with steam', 'Steam or humidity gives croissants and buns better volume and shine.', ['soner-sco-4mf', 'unox-xft133']],
          'pastry-many': ['A commercial convection oven', 'Bake a full rack at a time with a commercial convection oven with humidity.', ['unox-xv393', 'innofood-ktbf1a']],
          'cook-few': ['A compact combi oven', 'Bake, roast, steam and reheat in one machine.', ['unox-xv393', 'unox-xebc-04eu-e1rm']],
          'cook-mid': ['A combi oven', 'Bake, roast, steam and reheat in one machine, with programs your team can repeat.', ['unox-xebc-04eu-e1rm', 'unox-xeda-1011-exrs']],
          'cook-many': ['A large combi oven', 'For hotels and central kitchens, a 10-tray combi replaces several appliances.', ['unox-xeda-1011-exrs', 'unox-xeda-1021-exrs']]
        };
        return R[v.what + '-' + v.trays];
      }
    },
    'bakery-equipment-checklist-malaysia': { kind: 'checklist' }
  };
  var tool = TOOLS[handle];

  function picker(t) {
    var box = el('div', 'ga-tool');
    var state = {};
    box.innerHTML = '<div class="ga-tool-h"><span class="ga-eye">Interactive</span><h3>' + t.title + '</h3></div>';
    t.qs.forEach(function (q, qi) {
      var row = el('div', 'ga-q'); row.innerHTML = '<p><b>' + (qi + 1) + '</b>' + q.q + '</p>';
      var opts = el('div', 'ga-opts');
      q.a.forEach(function (o) {
        var b = el('button', 'ga-opt'); b.type = 'button'; b.textContent = o[1]; b.setAttribute('aria-pressed', 'false');
        b.addEventListener('click', function () {
          state[q.id] = o[0];
          Array.prototype.forEach.call(opts.children, function (x) { x.setAttribute('aria-pressed', String(x === b)); });
          show();
        });
        opts.appendChild(b);
      });
      row.appendChild(opts); box.appendChild(row);
    });
    var out = el('div', 'ga-result'); out.hidden = true; box.appendChild(out);
    function show() {
      if (t.qs.some(function (q) { return !state[q.id]; })) return;
      var r = t.result(state); if (!r) return;
      out.hidden = false;
      out.innerHTML = '<div class="ga-result-h"><small>We recommend</small><b>' + r[0] + '</b><p>' + r[1] + '</p></div>';
      var g = el('div', 'ga-pcs'); r[2].forEach(function (h) { g.appendChild(card(h)); }); out.appendChild(g);
      var ask = el('a', 'ga-btn ga-btn-ghost'); ask.target = '_blank'; ask.rel = 'noopener';
      ask.href = WA + encodeURIComponent('Hi SHOPYTHON, the guide suggested "' + r[0] + '" for me. Can you advise which model suits best?');
      ask.innerHTML = 'Ask us to confirm on WhatsApp &rarr;'; out.appendChild(ask);
      out.classList.remove('pop'); void out.offsetWidth; out.classList.add('pop');
    }
    return box;
  }

  function checklist() {
    var KEY = 'sf-guide-check-' + handle, saved = {};
    try { saved = JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) {}
    var items = [];
    secs.forEach(function (s) {
      if (!/stage|peringkat|阶段/i.test(s.querySelector('h2').textContent)) return;
      var ul = s.querySelector('ul'); if (!ul) return;
      ul.classList.add('ga-check');
      var stageItems = [];
      Array.prototype.forEach.call(ul.children, function (li, i) {
        var id = s.id + '-' + i;
        var name = (li.querySelector('strong') || li.querySelector('a') || li).textContent.replace(/:$/, '').trim();
        name = name.charAt(0).toUpperCase() + name.slice(1);
        var m = li.textContent.match(/RM([\d,]+)/);
        var it = { id: id, name: name, price: m ? +m[1].replace(/,/g, '') : 0, li: li };
        var cb = el('input'); cb.type = 'checkbox'; cb.checked = !!saved[id]; cb.setAttribute('aria-label', name);
        var lab = el('label', 'ga-tick'); lab.appendChild(cb); lab.appendChild(el('span'));
        li.insertBefore(lab, li.firstChild);
        li.classList.toggle('done', cb.checked);
        cb.addEventListener('change', function () { saved[id] = cb.checked; li.classList.toggle('done', cb.checked); try { localStorage.setItem(KEY, JSON.stringify(saved)); } catch (e) {} sum(); });
        it.cb = cb; items.push(it); stageItems.push(it);
      });
      var meter = el('div', 'ga-meter', '<i></i><span></span>'); ul.parentNode.insertBefore(meter, ul);
      s._meter = { el: meter, items: stageItems };
    });
    var bar = el('div', 'ga-sum-bar');
    bar.innerHTML = '<div><b class="n">0</b> items on your list <span class="t"></span></div><a class="ga-btn" target="_blank" rel="noopener">Get a quote for my list &rarr;</a>';
    body.appendChild(bar);
    function sum() {
      var on = items.filter(function (i) { return i.cb.checked; });
      var total = on.reduce(function (a, i) { return a + i.price; }, 0);
      bar.querySelector('.n').textContent = on.length;
      bar.querySelector('.t').textContent = total ? '· from about RM' + total.toLocaleString('en-MY') : '';
      bar.classList.toggle('show', on.length > 0);
      var msg = 'Hi SHOPYTHON, I used your equipment checklist. Please quote me for:\n' + on.map(function (i) { return '- ' + i.name; }).join('\n');
      bar.querySelector('a').href = WA + encodeURIComponent(msg);
      secs.forEach(function (s) {
        if (!s._meter) return; var d = s._meter.items.filter(function (i) { return i.cb.checked; }).length, n = s._meter.items.length;
        s._meter.el.querySelector('i').style.transform = 'scaleX(' + (n ? d / n : 0) + ')';
        s._meter.el.querySelector('span').textContent = d + ' of ' + n + ' ticked';
      });
    }
    sum();
    var intro = el('div', 'ga-tool ga-tool-note', '<div class="ga-tool-h"><span class="ga-eye">Interactive</span><h3>Tick off what you need</h3></div><p>Tick each machine you plan to buy. We keep a running estimate, and you can send the list to us on WhatsApp for a quote.</p>');
    var firstStage = secs.filter(function (s) { return s._meter; })[0];
    if (firstStage) firstStage.parentNode.insertBefore(intro, firstStage);
  }

  if (tool && tool.kind === 'picker') {
    var anchor = body.querySelector('.' + tool.after) || secs[0];
    if (anchor) anchor.parentNode.insertBefore(picker(tool), anchor.nextSibling);
  } else if (tool && tool.kind === 'checklist') {
    checklist();
  }

  /* ---- 9. copy link + reveal on scroll ---- */
  var copy = root.querySelector('.ga-copy');
  if (copy) copy.addEventListener('click', function () {
    var t = copy.textContent;
    (navigator.clipboard ? navigator.clipboard.writeText(location.href) : Promise.reject()).then(function () { copy.textContent = copy.getAttribute('data-done'); setTimeout(function () { copy.textContent = t; }, 1600); }).catch(function () {});
  });
  var reveal = Array.prototype.slice.call(root.querySelectorAll('.ga-sec, .ga-tool, .ga-more, .ga-cta'));
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    reveal.forEach(function (e) { e.classList.add('ga-rise'); });
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
    reveal.forEach(function (e) { io.observe(e); });
  }
})();
